import React from "react";
import { RefreshCw, Lock, BadgeCheck } from "lucide-react";

const POINTS = [
  { icon: RefreshCw, text: "New Cisco, Webex & Teams version support (CUCM 15 and beyond, new phone firmware, new runbooks) added automatically" },
  { icon: BadgeCheck, text: "No upgrade fees, no paid add-ons for new versions — ever" },
  { icon: Lock, text: "Your price is locked in as long as you stay subscribed" },
];

export const FreeUpdates = ({ compact = false }) => (
  <section data-testid="free-updates-banner" className="rounded-xl border border-emerald-600/30 bg-emerald-600/5 p-5">
    <div className="text-[11px] uppercase tracking-widest text-emerald-400 font-bold">Every future update included — free</div>
    {!compact && (
      <p className="text-[13px] text-zinc-400 mt-1">The platform keeps pace with the software you support. You never pay again to stay current.</p>
    )}
    <ul className={`mt-3 grid gap-2.5 ${compact ? "sm:grid-cols-3" : ""}`}>
      {POINTS.map((p) => (
        <li key={p.text} className="flex items-start gap-2 text-[13px] text-zinc-200">
          <p.icon className="h-4 w-4 text-emerald-400 mt-0.5 shrink-0" /> {p.text}
        </li>
      ))}
    </ul>
  </section>
);
